module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    ref: "child"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-99b1dff8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/EmptyPageView.vue
// module id = Kam/
// module chunks = 273